import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./WaitingPatients.module.css";
import waitingPatientsWhite from "../../assets/images/dashboard/waiting-patients-white.svg";
import { TableOptions } from "../../utils/messageConstants";
import { Link } from "react-router-dom";
let order = "desc";


export class WaitingPatients extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  handleBtnClick = () => {
    if (order === "desc") {
      this.refs.table.handleSort("asc", "name");
      order = "asc";
    } else {
      this.refs.table.handleSort("desc", "name");
      order = "desc";
    }
  };

  render() {
     const dashboardData = this.props.dashboardCounts;

    let role_id = localStorage.getItem("USER_INFO") && JSON.parse(localStorage.getItem("USER_INFO")).systemRole;

    return (
      <div>
        <div className={`card ${style.todayAppCard}`}>
          <Link to={{
            pathname: "/app/appoinmentlist",
            params: {
              isWaitingList: 1
            }
          }}>
            <div className={`card-header ${style.todayAppHeader}`}>
              <div className="d-flex align-items-center dashboard-list-box">
                <img src={waitingPatientsWhite} alt="Waiting Patients" />
                {role_id == 2 ?"My Waiting Patients":"Waiting Patients"}
              </div>
              <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
            </div>
          <div className="card-body dashboard-time-table-wrapper">
            <BootstrapTable ref="table" data={dashboardData.waitingList} options={TableOptions} version="4">
              <TableHeaderColumn
                dataField="party_name"
                isKey={true}
                // dataSort={true}
                width={"65%"}
              >
                Contact Name
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="payment_type"
                // dataSort={true}
                width={"35%"}
              >
                Type
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
          </Link>
        </div>
      </div>
    );
  }
}

export default WaitingPatients;
